import styled from "styled-components";
import { usePrivacy } from "../../../contexts/PrivacyContext";

const GroupList = ({ groups, selectedGroupIndex, handleGroupSelect,
    handleGroupAction, deleteSelectedGroup, isButtonDisabled,
    newGroupName, setNewGroupName }) => {
    const { maskGroupName } = usePrivacy();
    return (
        <DetailContainer>
            <TableHeader>
                <GroupHeader>Group Name</GroupHeader>
                <GroupHeader>Size</GroupHeader>
            </TableHeader>

            <PanelBody>
                <ScrollableContent>
                    {groups.map((group, index) => (
                        <GroupItem
                            key={index}
                            onClick={() => handleGroupSelect(index)}
                            $isSelected={selectedGroupIndex === index}
                        >
                            <Font>{maskGroupName(group.groupName)}</Font>
                            <Font1>{group.members.length}</Font1>
                        </GroupItem>
                    ))}
                </ScrollableContent>

                <ButtonWrapper>
                    <GroupInput
                        type="text"
                        value={newGroupName}
                        onChange={(e) => setNewGroupName(e.target.value)}
                        placeholder="Enter group name"
                    />
                    <AddButton onClick={handleGroupAction} disabled={isButtonDisabled}>
                        Add
                    </AddButton>
                    <DeleteButton
                        onClick={deleteSelectedGroup}
                        $disabled={selectedGroupIndex === null}
                    >
                        Delete
                    </DeleteButton>
                </ButtonWrapper>
            </PanelBody>
        </DetailContainer>
    );
};

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .5rem;          /* space-x-2 */
    margin-top: 1rem;    /* mt-4 */
`;



const BaseButton = styled.button`
  width: 85px;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 0.75rem;
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ $ringColor }) => $ringColor},
      0 0 0 4px rgba(0, 0, 0, 0.1);
  }
`;

const AddButton = styled(BaseButton)`
  background-color: #22c55e;

  &:hover {
    background-color: #16a34a;
  }

  &:focus {
    box-shadow: 0 0 0 2px #22c55e50;
  }
`;

const DeleteButton = styled(BaseButton)`
  background-color: #ef4444;
  opacity: ${props => props.$disabled ? 0.3 : 1};
  pointer-events: ${props => props.$disabled ? 'none' : 'auto'};

  &:hover {
    background-color: #dc2626;
  }

  &:focus {
    box-shadow: 0 0 0 2px #ef444450;
  }
`;

const GroupItem = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 1rem;
    background-color: ${props => props.$isSelected ? '#e3cdf2ff' : 'transparent'};
    cursor: pointer;

    &:hover {
        background-color: ${props => props.$isSelected ? '#e3cdf2ff' : '#f0f0f0'};
    }

    background-image: linear-gradient(#ccc, #ccc);
    background-repeat: no-repeat;
    background-position: center bottom; /* centered horizontally, at bottom */
    background-size: 94% 1px;           /* 80% width, 1px tall */
`;

const GroupInput = styled.input`
    flex: 1 1 0%;
    width: 100%;
    padding: 10px 20px;  /* px-4 py-2 */
    border: 1px solid #d1d5db;
    border-radius: 0.75rem;
    background: #fff;
    color: #111827;
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;
    &:focus {
        border-color: #9333ea;
        box-shadow: 0 0 0 1px #9333ea;
    }
`;

const DetailContainer = styled.div`
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    height: 550px; // Fixed height
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    min-width: 0;
`;

const ScrollableContent = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    overscroll-behavior: contain;
    margin: 0 -1rem; 
    border-radius: 0.5rem;
`;

const TableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;

const GroupHeader = styled.div`
    margin: 0 0 1rem 0;
    font-weight: 600;
    color: #1f2937; /* gray-800 */
`;

const Font = styled.div`
    font-size: 16px;
    text-align: left;
    width: 50%;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    color: #374151;
    flex: 1; 
`;

const Font1 = styled.div`
    flex: 1;
    font-size: 16px;
    text-align: left;
    width: 50%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #6b7280; /* gray-500 */
    font-size: 0.875rem;
    text-align: right;   
`;

const PanelBody = styled.div`
  background: #f9fafb;      /* gray-50 */
  border-radius: 0.5rem;
  min-height: 300px;
  padding: 0 1rem 1rem 1rem;            /* p-4 */
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;     
  justify-content: space-between;
  min-height: 0;   
`;

export default GroupList

